<template>
  <div class="float-right">
    <div >
      <v-tooltip left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn fab x-small elevation="0" @click="showTableConfig" v-on="on" height="12" width="12"
          ><v-icon x-small>fa-cog</v-icon></v-btn>
        </template>
        <span
        >{{$t('common.table_columns_settings')}}</span
        >
      </v-tooltip>
    </div>
    <table-config
        :is-visible="tableConfig.isVisible"
        :table="table"
        @hide="tableConfig.isVisible = false"
        :default-columns="defaultColumns"
    />
  </div>
</template>

<script>
import TableConfig from "@/components/common/TableConfig";
import CommonMixin from "@/mixins/common";
export default {
  name: "TableConfigBtn",
  components: {TableConfig},
  mixins: [CommonMixin],
  props: {
    table: null,
    defaultColumns: null,
  },
  data: () => ({
    tableConfig: {
      isVisible: false
    }
  }),
  methods: {
    showTableConfig() {
      this.tableConfig.isVisible = true;
    },
  }
}
</script>

<style scoped>

</style>